export default __webpack_public_path__ + "static/media/farfetch-logo.f6ad6c06.png";